export const CLEAN_DNI = /^0+|[^0-9kK]+/g
export const CURRENCY_DOTS = /(\d)(?=(?:[0-9,]{3})+\b)/g
export const FILTER_PATTERN_CHECK = /[\u0300-\u036f]/g
export const ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_CHECK = /^[a-zA-ZÀ-ÿ0-9\u00f1\u00d1\s.,_-]+$/
export const ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_FORMAT = /[^a-zA-ZÀ-ÿ0-9\u00f1\u00d1\s.,_-]/g
export const PATH_PARAM = /:\w+(?=\/?)/
